import axios from '@/common/http.js';
import {
  MessageBox,
  Message
} from 'element-ui'
var actions = {
	// 学段
	async getxueduan({commit,state},{schoolid}={}){
		axios.get('https://login.zhuoyuyun.com/index/basedata.Basic/getXueduan').then(({code,data})=>{
			let setaditor = JSON.parse(JSON.stringify(data.data));
			if(data.data.length>0){
			    for(let i=0; i<setaditor.length; i++){
			      setaditor[i].children=[];
			      setaditor[i].lid=setaditor[i].id;
			      setaditor[i].title=setaditor[i].xueduan_name;
				  setaditor[i].mid=setaditor[i].id;
			      data.data[i].children=[];
			      data.data[i].lid=data.data[i].id;
			      data.data[i].title=data.data[i].xueduan_name;
				  data.data[i].mid=data.data[i].id;
				  axios.get('https://login.zhuoyuyun.com/index/basedata.Basic/getXdSubject',{params:{xueduan_id:setaditor[i].id}}).then(res=>{
					 if(res.data.data.length>0){
					   for(let i=0; i<res.data.data.length; i++){
						 res.data.data[i].children=[];
						 res.data.data[i].lid=res.data.data[i].subject_id;
						 res.data.data[i].title=res.data.data[i].subject_name;
						 res.data.data[i].leaf=true;
					   }
					 }
					 setaditor[i].children = res.data.data;
				  })
			    }
			  }
			 commit('setSetdata',{
					data:setaditor,
					key:'xueduanlist'
				})
		     commit('setSetdata',{
					data:data.data,
					key:'xueduanlistset'
				})
			window.localStorage.setItem('xueduanlist',JSON.stringify(data.data))
		})
	},
	async getXdSubject({commit,state},id){
		  let {code,data} = await axios.get('https://login.zhuoyuyun.com/index/basedata.Basic/getXdSubject',{params:{xueduan_id:id}})
     if(data.data.length>0){
       for(let i=0; i<data.data.length; i++){
         data.data[i].children=[];
         data.data[i].lid=data.data[i].subject_id;
         data.data[i].title=data.data[i].subject_name;
         data.data[i].leaf=true;
       }
     }
     commit('setSetdata',{
     		data:data.data,
     		key:'subjectlist'
     	})

	},
	// 获取
	async getSchoolXQ({commit,state},{schoolid}={}){
		let {code,data,msg} = await axios({
			url: 'index/department.Dept/getSchoolXiaoqu',
			method: 'post',
			data:{
				schoolid:schoolid
			}
		})
		if(code=='10001' &&data.length>0){
			commit('setSetdata',{
				data:data,
				key:'xiaoqulist'
			})
		}else{
			commit('setSetdata',{
				data:[],
				key:'xiaoqulist'
			})
		}
	},
	// 获取全部权限列表
	async getRuleList({commit,state},{schoolid}={}){
		let {code,data,msg} = await axios({
			url: 'index/user.User/getRuleList',
			method:'get',
		})
		console.log(data)
	},
	//校本下载记录
	async downcount({commit,state},param){
		 await axios({
			url:'index/resource.Schres/downcount',
			method: 'post',
			params:param
		})
	},
	//上传下载记录
	async PostDownloadlog({commit,state},param){
		 await axios({
			url:'index/department.Dept/Downloadlog',
			method: 'post',
			params:param
		})
	},
	//上传查看记录
	async PostViewlog({commit,state},param){
		 await axios({
			url:'index/department.Dept/Viewlog',
			method: 'post',
			params:param
		})
	},
	//获取学校版本教材
	async getradios({commit,state}){
		let {data,code} = await axios({
			url:'index/base.Basedata/getgradeinfo',
			method: 'post',
		})
		if(code=='10001'){
			window.localStorage.setItem('radioslist',JSON.stringify(data))
			commit('setSetdata',{
				data:data,
				key:'getradioslist'
			})
		}
		console.log(data,code)
	},
	//获取章节
	async getchapterlist({commit,state},param){
		let {data,code} = await axios({
			url:'index/base.Basedata/getchapterlist',
			method: 'post',
			params:param
		})
		return data;

	},
	//获取信息
	async getinfotitle({commit,state},param){
		let {data,code} = await axios({
			url:'index/base.Basedata/getbindinfo',
			method:'get',
			params:param
		})
	}
}
export default actions



// WEBPACK FOOTER //
// ./src/store/modules/setting/action.js